import { type BlockerFunction, useBlocker } from "react-router";

type UseNavigationBlockerReturn = {
  isBlocked: boolean;
  proceed: () => void;
  cancel: () => void;
};

export function useNavigationBlocker(
  shouldBlock: BlockerFunction | boolean,
): UseNavigationBlockerReturn {
  const blocker = useBlocker(shouldBlock);

  return {
    isBlocked: blocker.state === "blocked",
    proceed: () => {
      if (blocker.state === "blocked") {
        blocker.proceed();
      }
    },
    cancel: () => {
      if (blocker.state === "blocked") {
        blocker.reset();
      }
    },
  };
}
